import { useTranslation } from "react-i18next";
import { InlineNotice } from "@/components/InlineNotice";
import type { RefreshProblem } from "./useDashboardHydration";

const KNOWN = new Set(["no_access", "source_off", "sign_in_required", "not_authorized", "needs_connection"]);

/** "You don't have access to HubSpot", from a refresh problem's code (backend detail is English, so not shown). */
export function useProblemText() {
  const { t } = useTranslation("microApps", { keyPrefix: "viewer.problems" });
  return (problem: RefreshProblem): string => {
    const code = KNOWN.has(problem.code) ? problem.code : "refresh_failed";
    const source = problem.source ?? t("thisSource");
    return t(code as "refresh_failed", { source });
  };
}

/** Why some live data couldn't refresh; the app keeps showing the last values it got. */
export function RefreshProblems({ problems }: Readonly<{ problems: RefreshProblem[] }>) {
  const { t } = useTranslation("microApps", { keyPrefix: "viewer.problems" });
  const text = useProblemText();
  if (problems.length === 0) return null;
  return (
    <div className="px-4 pt-3">
      <InlineNotice tone="warning">
        <span className="block">{t("title")}</span>
        <ul className="mt-1 list-disc pl-5">
          {problems.map((p) => (
            <li key={`${p.code}|${p.source ?? ""}`}>{text(p)}</li>
          ))}
        </ul>
      </InlineNotice>
    </div>
  );
}
